import dayjs from "dayjs";

import "dayjs/locale/es";
dayjs.locale("es");

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
dayjs.extend(isSameOrAfter);

import isToday from "dayjs/plugin/isToday";
dayjs.extend(isToday);

import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);
